export const GET_PRODUCT_SUCCESS="getProductsSuccess";
export const GET_PRODUCT_FAIL="getProductsFail";
export const GET_PRODUCT_DETAILS_REQUEST="getProductDetailRequest";
export const GET_PRODUCT_DETAILS_REQUEST_SUCCESS="getProductDetailsRequestSuccess";
export const GET_PRODUCT_DETAILS_REQUEST_FAIL="getProductsDetailsRequestFail";
export const GET_PRODUCT_DETAILS_REQUEST_RESET="getProductsDetailsRequestReset";
